<template>
    <v-card>
        <v-card-title class="font-italic grey--text darken-3 text-uppercase">{{ $t('buyer') }}</v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="12">
                    <v-autocomplete
                        v-model="data.user_id"
                        :label="$t('buyer')"
                        :items="buyers"
                        item-text="name"
                        item-value="id"
                        color="teal lighten-2"
                        item-color="teal lighten-2"
                        clearable
                    ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="4">
                    <v-text-field
                        :value="buyerInfo.name"
                        :label="$t('nameSurname')"
                        disabled
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                    <v-text-field
                        :value="buyerInfo.email"
                        label="Email"
                        disabled
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                    <v-text-field
                        :value="buyerInfo.phone"
                        :label="$t('phoneNumber')"
                        disabled
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
    import { MixinOrderInfo } from '../../../mixins';
    import { UsersService } from '../../../services';

    export default {
        name: 'BuyerInfo',
        mixins: [MixinOrderInfo],
        data() {
            return {
                key: 'buyerInfo',
                buyers: [],
            }
        },
        computed: {
            selectedBuyer() {
                return this.data.user_id ? this.buyers.find(item => item.id === this.data.user_id) : null;
            },
            buyerInfo() {
                const { name, email, phone } = this.selectedBuyer || this.order.buyer;

                return { name, email, phone };
            },
        },
        methods: {
            orderHandle(value) {
                const { buyer } = value;
                this.data = {
                    user_id: buyer.id,
                }
            },
            getBuyers() {
                const params = {
                    itemsPerPage: -1,
                    filters: {
                        is_buyer: 1,
                        is_checked: 1,
                    }
                }
                UsersService.getUsers(params)
                    .then(res => {
                        this.buyers = res.data.data;
                    })
                    .catch(console.log)
            },
        },
        created() {
            this.getBuyers();
        },
    }
</script>

<style scoped>

</style>
